/**
 * Utility class for enum operations
 */
export class EnumUtil {
  /**
   * Converts a value to an enum value if it exists in the enum, otherwise returns null.
   * @param value - The value to check (can be string, string array, or undefined)
   * @param enumObj - The enum object to check against
   * @returns The enum value if found, null otherwise
   */
  static toEnum<T extends Record<string, string | number>>(
    value: string | string[] | undefined | null | number | number[],
    enumObj: T,
  ): T[keyof T] | null {
    if (value === null || value === undefined) {
      return null;
    }
    const stringValue = Array.isArray(value) ? value[0] : value;
    if (stringValue === undefined || stringValue === null) {
      return null;
    }
    const enumValues = Object.values(enumObj);
    if (enumValues.includes(stringValue as T[keyof T])) {
      return stringValue as T[keyof T];
    }
    return null;
  }
}

